module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABOklEQVRYhe1YUQ7DIAh9LLv/mbgZ+9hcGIMqU9ea+BJCtSAgYFoJAEQEq+J2tgO92AGcjXtWgYjChhER6nMnj1QGiEhEAGaGx4+CmwoRqVIRY+ZD/pSrrzeKqHh2hNE7O7LUmksoKpssn4JR5dPCMbjEmgOo176c0iPdGQDE5UtlAJA3ZTMAPOc8mp4B7bg3bs3Ar85fIgNeEFNK6B898Et/7FMoyy95CmX4zoCh5T/mmgK4Mpb/pdwBnI2vn3qvYUc2nbXVu7Z7KzHL4chOTyDLl1D6WqWQnrMyNfkyjtbx9KxugVtCWkinVj/X0m7f6zEzf8lH5VTGev7j+aUcGo4C84xGRmoydq41OCBxteg51KqbRbSBNlhgUBN7C4+C7Zdiq7xvzoBVzMofBac3INLT8/865jc2VsAD/OxQEL/sCrMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEFAVS_A.png
// module id = 67
// module chunks = 0